/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
    .controller('CheckoutSuggestedPointsProductsController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {

        $scope.Model = $scope.Model || {};
        $scope.Control = $scope.Control || {};
        $scope.Control.Loading = false;

        $scope.Control.Form = {};

        var controlName = 'SuggestedPointsProducts';
        $scope.registerControl(controlName, $element.get(0));

        $scope.Control.reload = function () {

            var config = $element.get(0).config; 

            if (!config.ControlData.IsFromClient)
                config.ControlData.IsFromClient = true;

            if (config.LoaderData.Filters.length > 0) {

                var cartPointsGain = $scope.$parent.Order.Current.CartPointsGain;
                var accountPointsGain = $scope.$parent.Order.Current.AccountPointsGain;

                for (var i = 0; i < config.LoaderData.Filters.length; i++) {

                    if (config.LoaderData.Filters[i].Key == 'PointsPrice') {
                        config.LoaderData.Filters[i].ToValue = accountPointsGain;
                        break;
                    }
                }
            }

            $element.get(0).config = config;

            var deferred = $q.defer();
            ControlService.getCheckoutData("GetSuggestedPointsProductsData", $scope, $element).then(function (response) {

                $scope.Model = {};
                angular.extend($scope.Model, response);

                deferred.resolve(response);
                $scope.Control.Loading = false;
            }, function (error) {
                deferred.reject(error);
                $scope.Control.Loading = false;
            });
            return deferred.promise;
        };

        var addToCart = function (item) {
            var deferred = $q.defer();

            var dataItem = {
                id: item.Id,
                skuId: item.VariantId,
                path: item.Path || null,
                qty: 1
            };

            Vendd.Service.call({
                url: 'EcomService.svc/AddToCart',
                data: { item: dataItem },
                onSuccess: function (res) {

                    if (res.success) {
                        deferred.resolve(res);
                    } else {
                        deferred.reject();
                    }
                }
            });
            
            return deferred.promise;
        };

        $scope.Control.addToCart = function (item) {
            $scope.Control.Loading = true;

            var deferred = $q.defer();
            addToCart(item).then(function (response) {
                EventManager.trigger('cartchange');

                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                    $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                        deferred.resolve(response);
                        $scope.Control.Loading = false;
                    }, function (orderError) {
                        deferred.reject(orderError);
                        $scope.Control.Loading = false;
                    });
                }
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        };


        $scope.$parent.$watch('Order.Current.TotalPointsGain + Order.Current.TotalPointsPrice', function (prevValue, newValue) {
            $scope.Control.Loading = true;
            $scope.Control.reload(); 
        });
    })
    .directive('repeatDone', function () {
        return function (scope, element, attrs) {
            if (scope.$last) {
                $('.x-checkout-slider').each(function (i, wrapper) {

                    if (!$(wrapper).data('init'))
                        return;

                    var defOptions = {
                        slides: '> li',
                        fx: 'carousel',
                        log: false,
                        prev: $('.prev', $(wrapper)),
                        next: $('.next', $(wrapper)),
                        pager: $('.pager', $(wrapper)),
                        pagerTemplate: '<span></span>',
                        pauseOnHover: true,
                        timeout: 0,
                        carouselVisible: 3,
                        allowWrap:false
                    };


                    var opts = {};
                    $.extend(true, opts, defOptions);

                    var $list = $('.x-list ul', $(wrapper));
                    if ($list.parent().data('grouping')) {
                        if ($list.children().length > 1) {
                            $list.cycle(opts);
                        }
                    } else {
                        var $listChild = $list.find('> *');
                        if ($listChild.children().length > 1) {
                            $listChild.cycle(opts);
                        }
                    }
                });
            }
        };
    });
    
    
})();